import { withTypeSafeApiResult } from '@/packages/typesafe-result';

import {
  type IGetUndergroundMapMicrofrontendRequest,
  type TResponse,
  fetchGetUndergroundMapMicrofrontend,
} from '@/repositories/manually-added/shared/underground-map-frontend/v1';

export const fetchUndergroundMapMicrofrontendSafe = withTypeSafeApiResult<
  IGetUndergroundMapMicrofrontendRequest,
  TResponse
>(fetchGetUndergroundMapMicrofrontend);
